import {
    WithLoggedInAuthInfoProps,
    withRequiredAuthInfo,
} from "@propelauth/react";
import React, { useEffect, useState, Suspense } from "react";
import { BuilderProjectModel, Project } from "@models/project";
import { Link, useParams } from "react-router-dom";
import { getProject } from "../../api/ProjectLoader";
import FilesView from "../files/FilesView";
import {ProjectInfoBuilder} from "../projects/ProjectInfo";
import AuctionStatusView from "./AuctionStatusView";
import BidSummary from "../bid/BidTableView";
import QAWidget from "../qa_forum/qa_widget";
import { BuilderVEWidget } from "../ve/VEWidget";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";

function ViewProjectAsBuilder(props: WithLoggedInAuthInfoProps) {
    const [project, setProject] = useState<BuilderProjectModel | null>(null);
    const { project_id } = useParams<string>();
    const fileContext = {
        context: "project",
        permission: "view",
        project_id: project_id,
        parent_id: project_id,
        parent_type: "project",
        folder_id: project?.root.id,
    };

    useEffect(() => {
        setProject(null);
        if (project_id) {
            getProject(project_id, props.accessToken).then((data) => {
                console.log("ViewPorject Builder:", data);
                setProject(data);
            });
        }

    }, [project_id]);

    if (!project) {
        return <div><BaseLoadingSpinner/></div>;
    }

    return (
        <div className={"container"}>
            <ProjectInfoBuilder project={project} />
            <br />

            <AuctionStatusView
                round={project.current_round}
                bidViewData={project?.bidding_view} />
            <br />

            <BidSummary  />
            <br />

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <QAWidget />
                <BuilderVEWidget ve_summary={project.ve_summary} />
                <FilesView uploadContext={fileContext} />
            </div>
            <br />
        </div>
    );
}

export default withRequiredAuthInfo(ViewProjectAsBuilder);


